import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CacheService, CacheTarget } from '../state/cache/cache.service';

import * as CryptoUtils from '../utils/crypto.utils';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
	private readonly targets: CacheTarget[] = [
		{ method: 'POST', routeFragments: [environment.apiUrl, '/data-source/'] }
	];
	// TODO: Add routes that should poison the cache.
	private readonly poisonousTargets: CacheTarget[] = [
		{ method: 'PUT', routeFragments: [environment.apiUrl, '/data-source/'] }, // update
		{ method: 'DELETE', routeFragments: [environment.apiUrl, '/data-source/'] }, // delete
		{ method: 'POST', routeFragments: [environment.apiUrl, /.+\/data-source$/] }, // add
		{ method: 'POST', routeFragments: [environment.apiUrl, /.+\/data-source\/.*\/import\/csv$/] }, // import
		{ method: 'POST', routeFragments: [environment.apiUrl, /.+\/data-source\/.*\/store/] }, // store
		{ method: 'POST', routeFragments: [environment.apiUrl, '/asset/site/'] }, // upload / upload from URL
		{ method: 'DELETE', routeFragments: [environment.apiUrl, '/asset/site/'] }, // asset delete
		{ method: 'PATCH', routeFragments: [environment.apiUrl, '/asset/'] }, // asset update
		{ method: 'POST', routeFragments: [environment.apiUrl, /\/asset-collection(?:\/|$)/] }, // collection create, add asset
		{ method: 'DELETE', routeFragments: [environment.apiUrl, '/asset-collection/'] }, // collection delete, remove asset
		{ method: 'PUT', routeFragments: [environment.apiUrl, '/asset-collection/'] } // collection update
	];

	constructor(private readonly cacheService: CacheService) {
		this.cacheService
			.installConfig(this.targets, this.poisonousTargets);
	}

	public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.cacheService.isPoisonous(req.method, req.url)) {
			console.log('CACHE: Hit poison route. Dumping.');
			this.cacheService.clear();
		}

		const [canCache, duration] = this.cacheService.canCache(req.method, req.url);
		if (!canCache) {
			return next.handle(req);
		}

		return from(this.handle(req, next, duration));
	}

	private async handle(req: HttpRequest<any>, next: HttpHandler, customDuration?: number): Promise<HttpEvent<any>> {
		let hash: string;
		if (!environment.disableCacheInterceptor) {
			console.log('/////////CACHE-INTERCEPTOR//////////');
			if (req.body instanceof FormData) {
				hash = 'file-upload-' + Date.now();
			} else {
				hash = await CryptoUtils.hashObject(req.body);
			}
			console.log('CACHE: Hash', hash);

			const cacheResult = this.cacheService.get(req.method, req.urlWithParams, hash);
			if (cacheResult) {
				console.log('CACHE: Hit', cacheResult);
				return cacheResult;
			}

			console.log('CACHE: Miss');

			console.log('/////////END-CACHE-INTERCEPTOR//////////');
		}

		return (
			next.handle(req).pipe(
				tap((ev: HttpEvent<any>) => {
					if (ev instanceof HttpResponse && !environment.disableCacheInterceptor) {
						this.cacheService.put(req.method, req.urlWithParams, hash, ev);
					}
				})
			) as Observable<HttpEvent<any>>
		).toPromise();
	}
}
